const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/workstations.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/workstations.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { WorkstationsPendingState } from '@/features/calibration/components/WorkstationsPendingState';
import { calibrationStationsQuery } from '@/features/calibration/services/calibrationQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/calibration/workstations')({
  loader: ({
    context
  }) => context.queryClient.ensureInfiniteQueryData(calibrationStationsQuery()),
  pendingComponent: WorkstationsPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});